import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { addNotification } from 'modules/notifications/redux';
import { NotificationTypes } from 'modules/notifications';
import { RoutesApi } from '../api';
import { RouteActions } from '../redux';
import { NewRouteForm } from '../types';

const useCreateOrUpdateRoute = (
  closeModal: () => void,
): {
  loading: boolean;
  handleUpdateOrCreate: (values: NewRouteForm) => Promise<void>;
} => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleUpdateOrCreate = useCallback(
    async (values: NewRouteForm) => {
      setLoading(true);
      try {
        const returnedRoute = values.id
          ? await RoutesApi.updateRoute(values)
          : await RoutesApi.createRoute(values);
        dispatch(RouteActions.setRoutes([returnedRoute]));
        dispatch(
          addNotification({
            type: NotificationTypes.Success,
            message: `Route has been ${
              values.id ? 'updated' : 'created'
            } successfully.`,
          }),
        );
        closeModal();
      } catch (err) {
        dispatch(
          addNotification({
            type: NotificationTypes.Error,
            message: `Error while ${
              values.id ? 'updating' : 'creating a'
            } route.`,
          }),
        );
      } finally {
        setLoading(false);
      }
    },
    [dispatch, closeModal],
  );

  return {
    loading,
    handleUpdateOrCreate,
  };
};

export default useCreateOrUpdateRoute;
